import createApp from './main';
import '../../../style/details.scss';

function getClientPageData(pageDataId) {
  const id = pageDataId || 'modelData';
  const model = window?.document?.getElementById(id);
  return model === null ? { pageData: {} } : JSON.parse(model.innerHTML);
}

const { pageData: props } = getClientPageData();

const { app } = createApp(props);
if (props?.appProps?.['frontend.dev.toggles']?.useGlobalVueErrorHandler === true) {
  app.config.errorHandler = (err, instance, info) => {
    try {
      // forward error to newrelic
      window.newrelic?.addPageAction('PRODUCT-SITE:ERR:', {
        type: 'Vue Internal Error', errMessage: err.message, stack: err.stack, instance, info,
      });
      window.newrelic?.noticeError(err, { internalName: 'Vue internal error' });
      // eslint-disable-next-line no-console
      console.error(err);
    } catch (error) {
      // something unexpected happened, just throw the original error for Vue to handle
      throw err;
    }
  };
}
app.mount('#app');
